var _rect, _rect2, _rect3, _rect4, _rect5, _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgActivityLight = function SvgActivityLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.75,
    y: 10.75,
    width: 138.5,
    height: 138.5,
    rx: 69.25,
    stroke: "#F3F3F8",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 116,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 14,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 139,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F3F3F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "activity-light_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 24,
    width: 165,
    height: 112
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.074 95.778H27c-5.523 0-10-4.477-10-10V70c0-5.523 4.477-10 10-10h9.05c-.033-.329-.05-.663-.05-1v-8c0-5.523 4.477-10 10-10h13.813C69.99 30.515 84.234 24 100 24c15.766 0 30.01 6.515 40.187 17H153c5.523 0 10 4.477 10 10v8c0 .337-.017.671-.049 1H172c5.523 0 10 4.477 10 10v15.778c0 5.523-4.477 10-10 10h-9.074c.049.4.074.808.074 1.222v8c0 5.523-4.477 10-10 10h-9.282c-10.263 12.802-26.033 21-43.718 21-17.685 0-33.455-8.198-43.718-21H46c-5.523 0-10-4.477-10-10v-8c0-.414.025-.822.074-1.222Z",
    fill: "#FF4949"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#activity-light_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 112,
    height: 112,
    rx: 56,
    fill: "#F3F3F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 49,
    width: 127,
    height: 28,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.75,
    y: 41.75,
    width: 125.5,
    height: 26.5,
    rx: 9.25,
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 53,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 53,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 51A9.25 9.25 0 0 1 46 41.75h17.25v26.5H46A9.25 9.25 0 0 1 36.75 59v-8Z",
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.176 58.62c1.196 1.281.285 3.372-1.467 3.366l-8.25-.024c-1.752-.005-2.65-2.101-1.447-3.374l4.139-4.376a2 2 0 0 1 2.914.01l4.111 4.399Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.333,
    cy: 50.333,
    r: 2.333,
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 95,
    width: 127,
    height: 28,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.75,
    y: 87.75,
    width: 125.5,
    height: 26.5,
    rx: 9.25,
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 99,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 99,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.75 97A9.25 9.25 0 0 1 46 87.75h17.25v26.5H46a9.25 9.25 0 0 1-9.25-9.25v-8Z",
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.176 104.621c1.196 1.28.285 3.37-1.467 3.365l-8.25-.024c-1.752-.005-2.65-2.101-1.447-3.374l4.139-4.376a2 2 0 0 1 2.914.009l4.111 4.4Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.333,
    cy: 96.333,
    r: 2.333,
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.606,
    y: 70.222,
    width: 165,
    height: 35.778,
    rx: 10,
    fill: "#2D2062",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.75,
    y: 60.75,
    width: 163.5,
    height: 34.278,
    rx: 9.25,
    fill: "#fff",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.173,
    y: 75.333,
    width: 51.968,
    height: 5.111,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.819,
    y: 75.333,
    width: 15.591,
    height: 5.111,
    rx: 2,
    fill: "#E0DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 70A9.25 9.25 0 0 1 27 60.75h25.628v34.278H27a9.25 9.25 0 0 1-9.25-9.25V70Z",
    fill: "#F3F3F6",
    stroke: "#E7E6ED",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.093 83.442c1.213 1.276.305 3.383-1.455 3.378l-13.38-.04c-1.76-.004-2.656-2.117-1.435-3.386l6.712-6.979a2 2 0 0 1 2.891.01l6.667 7.017Z",
    fill: "#CFCDDC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.126,
    cy: 71.926,
    rx: 3.031,
    ry: 2.981,
    fill: "#CFCDDC"
  }))));
};

export { SvgActivityLight as ReactComponent };
export default "data:image/svg+xml;base64,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";